export const BackgroundBlob = () => (
  <svg
    className="h-full w-full"
    style={{ right: '95px' }}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 642 788"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M639.906 1079.81V814.284L329.712 762.189C486.716 762.189 689.233 728.608 458.549 530.716C725.204 586.666 650.6 156.151 549.491 -153H251.806L513.175 355.828C-59.1083 -634.744 -184.521 326.849 304.909 601.285C-235.077 459.613 -17.3038 1223.96 639.906 1079.81Z"
      fill="#D4D6EC"
    />
  </svg>
);

export const StarIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    className="mr-1"
  >
    <path
      d="M7.46588 1.53576L8.93704 4.50583C8.97049 4.58122 9.02313 4.64651 9.08969 4.69522C9.15626 4.74393 9.23441 4.77433 9.31639 4.78341L12.5641 5.26454C12.6581 5.27663 12.7467 5.31523 12.8196 5.37581C12.8925 5.4364 12.9468 5.51649 12.9759 5.60672C13.005 5.69694 13.0078 5.79359 12.984 5.88537C12.9603 5.97715 12.9109 6.06027 12.8416 6.12503L10.5007 8.44742C10.441 8.50324 10.3961 8.57312 10.3703 8.65068C10.3445 8.72825 10.3384 8.81105 10.3527 8.89155L10.9171 12.1577C10.9334 12.2515 10.9231 12.3481 10.8873 12.4364C10.8514 12.5247 10.7916 12.6011 10.7145 12.657C10.6373 12.7129 10.5461 12.7461 10.451 12.7526C10.3559 12.7593 10.261 12.739 10.1769 12.6944L7.25307 11.1492C7.17821 11.1124 7.09591 11.0933 7.0125 11.0933C6.9291 11.0933 6.84681 11.1124 6.77194 11.1492L3.84812 12.6944C3.76401 12.739 3.66903 12.7593 3.574 12.7526C3.47897 12.7461 3.38769 12.7129 3.31057 12.657C3.23344 12.6011 3.17356 12.5247 3.13773 12.4364C3.10191 12.3481 3.09158 12.2515 3.10792 12.1577L3.67233 8.85454C3.68663 8.77404 3.68058 8.69124 3.65473 8.61367C3.62887 8.53611 3.58403 8.46623 3.52429 8.41041L1.15563 6.12503C1.08555 6.0585 1.03627 5.97308 1.01375 5.87911C0.991238 5.78515 0.996453 5.68666 1.02877 5.5956C1.06108 5.50453 1.1191 5.42479 1.19581 5.36603C1.27253 5.30728 1.36463 5.27203 1.46096 5.26454L4.70861 4.78341C4.79059 4.77433 4.86876 4.74393 4.93532 4.69522C5.00187 4.64651 5.05451 4.58122 5.08797 4.50583L6.55913 1.53576C6.59919 1.44926 6.66316 1.37602 6.7435 1.32469C6.82383 1.27337 6.91717 1.24609 7.0125 1.24609C7.10783 1.24609 7.20117 1.27337 7.28151 1.32469C7.36184 1.37602 7.42581 1.44926 7.46588 1.53576Z"
      fill="black"
      stroke="black"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SignInHSIcon = ({ active }: { active: boolean }) => {
  if (active) {
    return (
      <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.5" y="0.5" width="24" height="24" rx="4" fill="black" />
        <path d="M14.9853 5.2998L14.0202 10.7898L11.185 13.1071L12.5569 5.2998H9.80873L7.26685 19.6998H10.015L10.7209 15.7159L13.5663 13.3809L12.4434 19.6998H15.1931L17.7335 5.2998H14.9853Z" fill="#D3FB52" />
      </svg>
    );
  }
  return (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="24" height="24" rx="4" fill="#D3FB52" />
      <path d="M14.9853 5.2998L14.0202 10.7898L11.185 13.1071L12.5569 5.2998H9.80873L7.26685 19.6998H10.015L10.7209 15.7159L13.5663 13.3809L12.4434 19.6998H15.1931L17.7335 5.2998H14.9853Z" fill="black" />
    </svg>
  );
};

export const EmailIcon = () => (
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_5886_38363)">
      <path d="M5.11157 17.6429V7.35721C5.11157 6.72604 5.62325 6.21436 6.25443 6.21436H18.8259C19.4571 6.21436 19.9687 6.72602 19.9687 7.35721V17.6429C19.9687 18.2741 19.4571 18.7858 18.8259 18.7858H6.25443C5.62325 18.7858 5.11157 18.2741 5.11157 17.6429Z" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M5.11157 9.07129L11.8896 13.7638C12.281 14.0347 12.7993 14.0347 13.1907 13.7638L19.9687 9.07129" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_5886_38363">
        <rect width="16" height="16" fill="white" transform="translate(4.54004 4.5)" />
      </clipPath>
    </defs>
  </svg>
);

export const ArrowLeft = () => {
  return (
    <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M16.4287 7.99609H1.57153" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8.42868 1.14258L1.57153 7.99972L8.42868 14.8569" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};
